import React from "react";
import { useTranslation } from "react-i18next";
import List from "@material-ui/core/List";
import { makeStyles } from "@material-ui/core/styles";
import LibraryBooksOutlinedIcon from "@material-ui/icons/LibraryBooksOutlined";
import { Dashboard, User, Log } from "components/Icons";
import DrawerItem from "../DrawerItem";
import Authorized from "components/Authorized";
import ROLES from "shared/roles";

const useStyles = makeStyles(
	theme => ({
		list: {
			width: 300,
			paddingTop: 0,
			paddingBottom: 0,
			"& .MuiListSubheader-root": {
				lineHeight: "30px"
			}
		},
		listSubHeader: {
			display: "flex",
			justifyContent: "space-between",
			alignItems: "center"
		}
	}),
	{ name: "Drawer" }
);

const Drawer = () => {
	const { t } = useTranslation();
	const classes = useStyles();

	return (
		<List className={classes.list}>
			<DrawerItem
				to="/dashboard"
				text={t("common.dashboard")}
				icon={<Dashboard style={{ stroke: "#000" }} />}
			/>
			<Authorized hasAnyAuthorities={[ROLES.ADMINISTRATOR]}>
				<DrawerItem
					to="/users"
					text={t("pages.user.list")}
					icon={<User style={{ stroke: "#000" }} />}
				/>
				<DrawerItem to="/audit-log" text={t("pages.auditLog.log")} icon={<Log />} />
				<DrawerItem
					to="/system-log"
					text={t("pages.systemlog.log")}
					icon={<LibraryBooksOutlinedIcon style={{ color: "black" }} />}
				/>
			</Authorized>
			<p style={{ textAlign: "center" }}>&#169; Reliable Energy Group Zrt.</p>
			<p style={{ textAlign: "center" }}>2019 | Minden jog fenntartva!</p>
		</List>
	);
};

export default Drawer;
